// Selling something back (owner 2026-10-30), the client side of backend app/game/resale.py: furniture, decorations and
// farm objects pay RESALE_PERCENT of their price; a piece bought before the 2026-10-20 price rise (counted per item in
// farm.old_price_objects) pays that much of its OLD price, so it never sells at a profit.
export const RESALE_PERCENT = 80;

export const resale = (price) => Math.floor((price * RESALE_PERCENT) / 100);

/** What selling one `item` that costs `price` today pays: {coins, old} — old: an old-price one goes first. */
export function sellBack(oldCounts, legacyPrices, item, price) {
  const legacy = legacyPrices?.[item];
  const old = (oldCounts?.[item] ?? 0) > 0 && legacy != null;
  return { coins: resale(old ? legacy : price), old };
}

/** The confirm's line under its price. */
export const saleNote = ({ old }) => (old ? `Kupione przed podwyżką cen: ${RESALE_PERCENT}% starej ceny.` : `Dostaniesz ${RESALE_PERCENT}% ceny.`);

/** A placed house / yard piece's {coins, old}, or null when it is not for sale (a buda: its animal lives in it). */
export function placementSale(raw, placement) {
  const kind = { furniture: 'furniture', decoration: 'decorations' }[placement?.type];
  const spec = kind ? raw?.catalog?.[kind]?.[placement.item] : null;
  return spec ? sellBack(raw.farm?.old_price_objects, raw.catalog.legacy_prices, placement.item, spec.price) : null;
}
